<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head"></div>
          <div class="modal-con">
            <div class="modal-txt">
              <p>고인 사망시 나이 13세 미만만 가능합니다.</p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn primary medium" @click="close">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue';

const props = defineProps(['data']);
const { title, contents, callBackText } = toRefs(props.data);
const { fnCallBack } = props.data;
const emits = defineEmits(['close']);

const close = () => {
  if (fnCallBack) fnCallBack();

  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
